import React from 'react';
import {AnimatePresence} from 'framer-motion';
import {initSmoothScroll, jumpTo} from './src/components/utilities/smoothScroll';

export const wrapPageElement = ({element}) => (
	<AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
);

// Started here rather than in Layout, which unmounts on every navigation.
export const onInitialClientRender = () => {
	initSmoothScroll();
};

export const shouldUpdateScroll = ({
	routerProps: { location },
	getSavedScrollPosition,
  }) => {
	// Hash targets are handled in Layout once the page transition finishes.
	// Forcing a position here would scroll straight back to the top.
	if (location.hash) {
	  return false;
	}

	// jumpTo goes through Lenis when it's running. A bare window.scrollTo
	// would move the page out from under Lenis and leave its internal
	// position desynced from the real one.
	if (location.action === 'PUSH') {
	  window.setTimeout(() => jumpTo(0), 300);
	} else {
	  const savedPosition = getSavedScrollPosition(location);
	  window.setTimeout(() => jumpTo(savedPosition ? savedPosition[1] : 0), 300);
	}
	return false;
  };
